import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { HeaderNavigationLinkConfigInterface } from './interfaces/link-config.interface';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-organizer-shared-layout-dashboard-header-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class OrganizerSharedLayoutDashboardHeaderNavigationComponent
  implements OnChanges
{
  @Input() public unreadMessagesNumber = 0;

  public readonly linksConfig: HeaderNavigationLinkConfigInterface[] = [
    {
      labelKey: 'organizer.header.navigation.planning',
      routerLink: '/organizer.planning.planning',
      iconName: VtmnPlayIconTypeEnum.CalendarCheck,
    },
    {
      labelKey: 'organizer.header.navigation.activities',
      routerLink: '/organizer.activity.list',
      iconName: VtmnPlayIconTypeEnum.ListCheck,
    },
    {
      labelKey: 'organizer.header.navigation.messages',
      routerLink: '/organizer.messaging.inbox',
      iconName: VtmnPlayIconTypeEnum.Message,
    },
  ];

  public ngOnChanges(simpleChanges: SimpleChanges): void {
    // update the number of unread message, a getter leads to infinite update
    this.linksConfig[2].totalNotifications =
      simpleChanges.unreadMessagesNumber.currentValue;
  }
}
